<template>
  <!-- Layout registrado como `navbar-layout` em main.js, mas hoje NENHUMA rota o seleciona
       via meta.layout (só `default-layout` e `empty-layout` estão em uso). O tratamento aqui
       é o mínimo para ele não nascer quebrado se voltar a ser usado: largura fluida, gutter
       vindo do token e alvo de toque adequado no link. -->
  <nav class="navbar-layout-nav" :aria-label="$t('Navegação')">
    <ul class="nav">
      <li class="nav-item">
        <router-link to="/" class="nav-link">Voltar para a Home</router-link>
      </li>
    </ul>
  </nav>
  <slot></slot>
</template>

<style scoped>
.navbar-layout-nav {
  padding: var(--space-4) var(--gutter-page);
}

.navbar-layout-nav .nav-link {
  display: inline-flex;
  align-items: center;
  min-height: 44px;
}
</style>

